import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import loginActions from 'redux/actions/loginActions'
import { localize } from 'helpers/translator'
import { loginSelectors } from 'redux/selectors'

const LmsLoginConfirm = props => (
	<Confirm
		btTwo={localize('lms_confirm_button')}
		alertMessage={props.lmsConfirmText}
		actionButtonType={0}
		actionTwo={() => {
			props.actions.lmsModalConfirmed()
		}}
		closeButton={false}
	/>
)

function mapStateToProps(state) {
	return loginSelectors.loginLmsSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		lmsModalConfirmed: loginActions.lmsModalConfirmed,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LmsLoginConfirm)
